/**
 * Dependency Injection Keys for Vue 3
 *
 * Provides type-safe injection keys for service dependencies
 * following Vue 3 provide/inject best practices
 */

import { InjectionKey } from 'vue'
import CallRecordingService from './callRecordingService'
import IVRJourneyService from './ivrJourneyService'
import TranscriptionService from './transcriptionService'
import CallAuditLogService from './callAuditLogService'
import ActivationService from './activationService'
import VoiceService from './voiceService'
import { ErrorHandlingService } from './errorHandlingService'
import PatientNameService from './patientNameService'
import AudioNoteService from './audioNoteService'

/**
 * Injection keys for services
 * Use these with provide/inject for type safety
 */
export const CallRecordingServiceKey: InjectionKey<CallRecordingService> = Symbol('CallRecordingService')
export const IVRJourneyServiceKey: InjectionKey<IVRJourneyService> = Symbol('IVRJourneyService')
export const TranscriptionServiceKey: InjectionKey<TranscriptionService> = Symbol('TranscriptionService')
export const CallAuditLogServiceKey: InjectionKey<CallAuditLogService> = Symbol('CallAuditLogService')
export const ActivationServiceKey: InjectionKey<ActivationService> = Symbol('ActivationService')
export const PatientNameServiceKey: InjectionKey<PatientNameService> = Symbol('PatientNameService')
export const VoiceServiceKey: InjectionKey<VoiceService> = Symbol('VoiceService')
export const ErrorHandlingServiceKey: InjectionKey<ErrorHandlingService> = Symbol('ErrorHandlingService')
export const AudioNoteServiceKey: InjectionKey<AudioNoteService> = Symbol('AudioNoteService')

/**
 * Service factory functions
 * These create new instances of services for dependency injection
 */
export const createServices = () => {
  // Create shared services first (dependencies)
  const errorHandlingService = new ErrorHandlingService()

  // Create services that depend on others
  const voiceService = new VoiceService(errorHandlingService)

  return {
    callRecordingService: new CallRecordingService(),
    ivrJourneyService: new IVRJourneyService(),
    transcriptionService: new TranscriptionService(),
    callAuditLogService: new CallAuditLogService(),
    activationService: new ActivationService(),
    patientNameService: new PatientNameService(),
    audioNoteService: new AudioNoteService(),
    voiceService,
    errorHandlingService
  }
}
